import React, { useState, useEffect } from "react";
import axios from "axios";
import MiniDrawer from "../../components/MiniDrawer/MiniDrawer";
import Wrapper from "../../components/UI/Wrapper";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";

function DutySlipDetails() {
  return (
    <>
      <div className="d-flex flex-row app">
        <MiniDrawer />
        <div
          className="container-fluid"
          style={{ padding: "4rem 1rem 1rem 1rem", backgroundColor: "#F4F4F4" }}
        >
          <div
            className="d-flex flex-column w-100"
            style={{ backgroundColor: "#F4F4F4" }}
          >
            <div
              className="country-header"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "1rem",
              }}
            >
              <div>
                <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
                  <b> Duty Slip Details </b> | <HomeOutlinedIcon /> &gt;
                  <a style={{ cursor: "pointer" }}>Human Resources </a>
                  <span style={{ fontSize: "20px" }}>
                    &gt; Duty Slip Details
                  </span>
                </h1>
              </div>
              <div style={{ backgroundColor: "#682465" }}>
                <h5
                  style={{
                    color: "white",
                    fontSize: "16px",
                    padding: "10px",
                  }}
                >
                  Lead Id: -
                </h5>
              </div>
            </div>
            <Wrapper className="LeadDetails">
              {/* ----------------------------------Quotation builder-------------------------------- */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div>
                  <b style={{ textDecoration: "underline" }}>
                    INTERNATINAL EXPORT
                  </b>
                </div>
              </div>
            </Wrapper>
            <br></br>
            <div>
              <Wrapper className="LeadDetails">
                <div className="viewLeadDetails-form border-none rounded">
                  {/* Header */}
                  <div
                    className="p-2 mb-4"
                    style={{
                      background: "#5B489D",
                      color: "white",
                      fontWeight: "bold",
                      borderTopLeftRadius: "5px",
                      borderTopRightRadius: "5px",
                    }}
                  >
                    <span style={{ fontSize: "18px" }}>Relocation Details</span>
                  </div>

                  {/* Body */}
                  <div className="p-0" style={{ color: "#6A6A6A" }}>
                    {/* Row 1 */}
                    <div className="row m-0">
                      <div
                        className="col-3 fw-bold border p-2"
                        style={{ background: "#f5f5f5" }}
                      >
                        Customer Name
                      </div>
                      <div className="col-3 border p-2">Ubaid Sheikh</div>
                      <div
                        className="col-3 fw-bold border p-2"
                        style={{ background: "#f5f5f5" }}
                      >
                        Lead ID
                      </div>
                      <div className="col-3 border p-2">57835</div>
                    </div>

                    {/* Row 2 */}
                    <div className="row m-0">
                      <div
                        className="col-3 fw-bold border p-2"
                        style={{ background: "#f5f5f5" }}
                      >
                        Pet Name
                      </div>
                      <div className="col-3 border p-2">Bruno</div>
                      <div
                        className="col-3 fw-bold border p-2"
                        style={{ background: "#f5f5f5" }}
                      >
                        Pet Type & Breed
                      </div>
                      <div className="col-3 border p-2">
                        Dog | German Shepherd
                      </div>
                    </div>

                    {/* Row 3 */}
                    <div className="row m-0">
                      <div
                        className="col-3 fw-bold border p-2"
                        style={{ background: "#f5f5f5" }}
                      >
                        Sale Coordinator
                      </div>
                      <div className="col-3 border p-2">Dhruv Ahuja</div>
                      <div
                        className="col-3 fw-bold border p-2"
                        style={{ background: "#f5f5f5" }}
                      >
                        Operation Coordinator
                      </div>
                      <div className="col-3 border p-2">Hitesh Gaur</div>
                    </div>

                    {/* Row 4 */}
                    <div className="row m-0">
                      <div
                        className="col-3 fw-bold border p-2"
                        style={{ background: "#f5f5f5" }}
                      >
                        Service Type
                      </div>
                      <div className="col-3 border p-2">
                        International Export
                      </div>
                      <div
                        className="col-3 fw-bold border p-2"
                        style={{ background: "#f5f5f5" }}
                      >
                        AWB no. / PNR no.
                      </div>
                      <div className="col-3 border p-2">123-4567890</div>
                    </div>

                    {/* Row 5 */}
                    <div className="row m-0">
                      <div
                        className="col-3 fw-bold border p-2"
                        style={{ background: "#f5f5f5" }}
                      >
                        Starting Kilometre Count
                      </div>
                      <div className="col-3 border p-2">-</div>
                      <div
                        className="col-3 fw-bold border p-2"
                        style={{ background: "#f5f5f5" }}
                      >
                        Ending Kilometre Count
                      </div>
                      <div className="col-3 border p-2">-</div>
                    </div>
                  </div>
                </div>
              </Wrapper>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DutySlipDetails;
